<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0">

            <div class="w-100 d-flex flex-column justify-content-between">
                <div class="px-1  bg-white flex-fill">
                    <div class="d-flex flex-column  mt-3 mb-2">
                        <div class="title d-flex justify-content-between mb-2">Finca
                       
                        <div>
                               <feather-icon  @click="modalShow = !modalShow" icon="Edit2Icon" size="20" />
                               <feather-icon class="" @click="modalTrashShow = !modalTrashShow" icon="TrashIcon" size="20" />
                        </div>
                    </div> 
                        <div class="mb-2">
                            <b-card v-if="!modalShow" no-body class="overflow-hidden" v-for="(data) in initialData"
                                style="max-width: 540px;">
                                <b-row no-gutters>
                                    <b-col >
                                        <b-card-body title="Finca 1. El cenizaro">
                                            <b-card-text>
                                            <div class="d-flex flex-fill align-items-center justify-content-between">
                                                 <div> HA de Pastos:</div> 
                                                 <div>{{ data.Ha }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> Número de Apartos:</div> 
                                                 <div>{{ data.Apartos }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> Sistema:</div> 
                                                 <div>{{ data.Sistema }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> Provincia:</div> 
                                                 <div>{{ data.Provincia }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div>  Cantón:</div> 
                                                 <div>{{ data.Cantón }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> Distrito:</div> 
                                                 <div>{{ data.Distrito }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> HA de Pastos:</div> 
                                                 <div>{{ data.Ha }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> HA de Pastos:</div> 
                                                 <div>{{ data.Ha }}</div>
                                            </div>
                                              <div class="d-flex align-items-center justify-content-between">
                                                 <div> HA de Pastos:</div> 
                                                 <div>{{ data.Ha }}</div>
                                            </div>
                                            </b-card-text>
                                        </b-card-body>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <div class="preTitle modalRad">
                    

                                <b-modal  centered v-model="modalShow" hide-footer hide-header>

                                    <div class="d-flex align-items-center justify-content-center subTitle pt-3"> Finca 1. El
                                        cenizaro</div>
                                    <div class="d-flex align-items-center justify-content-center subTitle">Editar</div>

                                    <validation-observer ref="FarmView" #default="{ invalid }">
                                        <div class="">
                                            <b-form class="mt-2">
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>HA de Pastos:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="HA"
                                                                vid="HA" rules="required">
                                                                <b-form-input id="HA" v-model="ha" name="HA"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>Número de Apartos:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="apartos"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label> Sistema:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="username"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label> Provincia:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Apartos"
                                                                vid="Apartos" rules="required">
                                                                <b-form-input id="Apartos" v-model="provincia"
                                                                    name="Apartos"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label>Cantón:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Cantón"
                                                                vid="Cantón" rules="required">
                                                                <b-form-input id="Cantón" v-model="cantón"
                                                                    name="Cantón"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-between align-items-center pb-2">
                                                        <label>Distrito:</label>
                                                        <div class="w-50">
                                                            <validation-provider #default="{ errors }" name="Distrito"
                                                                vid="Distrito" rules="required">
                                                                <b-form-input id="Distrito" v-model="distrito"
                                                                    name="Distrito"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </b-form>
                                        </div>
                                    </validation-observer>


                                </b-modal>
                                   <b-modal size="sm" centered v-model="modalTrashShow" hide-footer hide-header>
                                   <div class="d-flex  align-items-end justify-content-end"> <feather-icon  @click="modalTrashShow = !modalTrashShow" icon="XIcon" size="20" /></div>
                                   <div class="d-flex flex-column align-items-center justify-content-center">  
                                        <span class="deleteModal mt-3"> ¿Desea eliminar? </span>
                                        <b-button class="deleteButton mt-2 mb-2">Eliminar</b-button>
                                    </div>
                                   </b-modal>
                            </div>

                        </div>
                       <img src="@/assets/images/ganImage/datalogfarmmap.png" />
                    </div> 
                        
                </div>
                <ControlMenu />
            </div>
        </b-row>

    </div>
</template>

<script>
import {
    BRow, BCol, BCardBody, BCard, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import store from '@/store/index'
export default {
    components: {
        BRow,
        BImg,
        BCol,
        BButton,
        BForm,
        BCardText,
        BCardTitle,
        BFormGroup,
        BFormInput,
        BInputGroup,
        ControlMenu,
        BCardBody,
        BCard,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            status: '',
            initialData: [{ Ha: 13, Apartos: 5, Sistema: "Doble Propósito", Provincia: "Limón", Cantón: "Pococí", Distrito: "Guápiles" }],
            modalShow: false,
            modalTrashShow:false,
            username: '',
            distrito:'',
            ha:'',
            cantón:'',
            provincia:'',
            sistema:'',
            apartos:'',
            
        }
    },

}
</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.subTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
}

.preTitle{
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    color: #5E5873;
}
.dataLog {
    font-weight: 500;
    font-size: medium;
    color: #5E8F23;
}

.deleteModal{
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
}
 .deleteButton{
    border-color: #EA5455 !important;
    padding: 10px 22px;
    box-shadow: inset 0px -3px 0px rgba(255, 0, 0, 0.2) !important;
    border-radius: 49px;
    width: 107px;
    height: 37px;
    background-color: #EA5455 !important;
    mix-blend-mode: normal;
    box-shadow: inset 0px -3px 0px rgba(0, 0, 0, 0.2);

}
#__BVID__40___BV_modal_content_{
    border-radius: 43px;
}
#__BVID__59___BV_modal_content_{
    border-radius: 43px;
}
#__BVID__41___BV_modal_content_{
    border-radius: 25px;
}
#__BVID__60___BV_modal_content_{
    border-radius: 25px;
}

.model-content {
    border-radius:30px;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>
